import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import SEO from "../components/SEO";
import "./Cancelled.css";

const Cancelled = () => {
  return (
    <div>
      <SEO
        title="Payment Canceled"
        description="Your payment was cancelled."
        path="/cancel"
        robots="noindex, nofollow"
      />
      <Header />
      <div className="canceled-container">
        <h1>Payment Canceled</h1>
        <p>Your payment has been cancelled.</p>
        <p>
          If you believe this is an error or need assistance, please contact our customer support.
        </p>
      </div>
      <Footer />
    </div>
  );
};

export default Cancelled;
